import { gql, useQuery } from '@apollo/client';
import { ActivityDayAvailability, QueryListActivityAvailabilityArgs } from './types';

const LIST_ACTIVITY_AVAILABILITY = gql`
  query listActivityAvailability(
    $activityId: ID!
    $startDate: String!
    $endDate: String!
  ) {
    listActivityAvailability(
      activityId: $activityId
      startDate: $startDate
      endDate: $endDate
    ) {
      day
      isOpen
    }
  }
`;

const useListActivityAvailabilityQuery = (
  activityId: string,
  startDate: string,
  endDate: string
) => {
  return useQuery<
    { listActivityAvailability: ActivityDayAvailability[] },
    QueryListActivityAvailabilityArgs
  >(LIST_ACTIVITY_AVAILABILITY, {
    variables: { activityId, startDate, endDate },
    fetchPolicy: 'network-only',
  });
};

export default useListActivityAvailabilityQuery;
